module.exports = __webpack_public_path__ + "img/equip-top.33875057.jpg";